import { render, staticRenderFns } from "./search_params_summary.vue?vue&type=template&id=5bc8567d&scoped=true&"
import script from "./search_params_summary.vue?vue&type=script&lang=js&"
export * from "./search_params_summary.vue?vue&type=script&lang=js&"
import style0 from "./search_params_summary.vue?vue&type=style&index=0&id=5bc8567d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc8567d",
  null
  
)

export default component.exports